import { createRoot } from 'react-dom/client';
import SettingsApp from '../SettingsApp';

// Run this IMMEDIATELY before anything else
(function() {
  const savedTheme = localStorage.getItem('havenlytics-theme');
  if (savedTheme === 'dark') {
    // Add class and force background
    document.body.classList.add('dark-mode');
    document.body.style.background = 'linear-gradient(135deg, #1a1a2e 0%, #16213e 100%)';
    document.body.style.backgroundColor = '#1a1a2e';
    document.documentElement.style.background = '#1a1a2e';
  }
})();

const initHavenlyticsAdminSettings = () => {
  const container = document.getElementById('HvnlyNab_admin_dashboard');
  if (!container) return;

  const root = createRoot(container);
  root.render(<SettingsApp />);
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initHavenlyticsAdminSettings);
} else {
  initHavenlyticsAdminSettings();
}

export default initHavenlyticsAdminSettings;